import { inputTypes } from '../helpers/enums';

export const expenseCategories = [
  { value: 'not-selected', label: 'Select category' },
  { value: 'salaries', label: 'Salaries' },
  { value: 'software', label: 'Software' },
  { value: 'office', label: 'Office' },
  { value: 'travel', label: 'Travel' },
  { value: 'other', label: 'Other' },
  { value: 'refund', label: 'Refund' },
];

export const recurringFrequencies = [
  { value: 'not-selected', label: 'Select frequency' },
  { value: 'once', label: 'Once' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'annually', label: 'Annually' },
];

export const expenseForm = {
  name: {
    label: 'Name',
    type: inputTypes.text,
    placeholder: 'Enter name',
    validation: {
      required: true,
      minLength: 1,
    }
  },
  amount: {
    label: 'Amount',
    type: inputTypes.number,
    placeholder: 'Enter amount',
    validation: {
      required: true,
      minLength: 1,
    }
  },
  category: {
    label: 'Category',
    type: inputTypes.select,
    options: expenseCategories,
    validation: {
      required: true,
    }
  },
  startedAt: {
    label: 'Date',
    type: inputTypes.date,
    validation: {
      required: true,
    }
  },
  finishedAt: {
    label: 'End Date',
    type: inputTypes.date,
  },
  recurringFrequency: {
    label: 'Recurring Frequency',
    type: inputTypes.select,
    options: recurringFrequencies,
  },
};

export const monthlySalaryExpenseForm = {
  user: {
    label: 'User',
    type: inputTypes.usersSelect,
    multiple: false,
    validation: {
      required: true,
    }
  },
  amount: {
    label: 'Amount',
    type: inputTypes.number,
    placeholder: 'Enter amount',
    validation: {
      required: true,
      minLength: 1,
    }
  },
  startedAt: {
    label: 'Date',
    type: inputTypes.date,
    validation: {
      required: true,
    }
  },
  finishedAt: {
    label: 'End Date',
    type: inputTypes.date,
  },
};
